"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeEntityListRows = computeEntityListRows;
exports.parseEntityListTypesAttr = parseEntityListTypesAttr;
function computeEntityListRows(entities, entityTypes, entitiesService, embed = {}) {
    const typeMap = new Map(entityTypes.map(t => [t.id, t]));
    // Adventure-edit resilience: hide instances whose type_id is no longer declared.
    let list = entities.filter(e => typeMap.has(e.typeId));
    if (embed.types && embed.types.length > 0) {
        const allowed = new Set(embed.types);
        list = list.filter(e => allowed.has(e.typeId));
    }
    if (embed.parentEntityId === null) {
        list = list.filter(e => !e.parentEntityId);
    }
    else if (embed.parentEntityId !== undefined) {
        const p = embed.parentEntityId.trim();
        list = list.filter(e => e.parentEntityId === p);
    }
    const contentVariable = typeof embed.contentVariable === 'string' ? embed.contentVariable.trim() : '';
    const rows = list.map(e => {
        const typeDef = typeMap.get(e.typeId);
        const row = {
            entityId: e.uuid,
            typeId: e.typeId,
            displayName: entitiesService.getDisplayName(e.uuid, typeDef?.displayName),
            parentEntityId: e.parentEntityId,
            startSceneId: typeDef?.startSceneId ?? ''
        };
        if (contentVariable) {
            const raw = entitiesService.getEntityVariable(e.uuid, contentVariable)?.value;
            const asStr = raw === undefined || raw === null ? '' : String(raw).trim();
            if (asStr) {
                row.content = asStr;
            }
        }
        return row;
    });
    const sort = embed.sort ?? 'name';
    if (sort === 'created') {
        const created = new Map(entities.map(e => [e.uuid, e.createdAtMs]));
        rows.sort((a, b) => (created.get(a.entityId) ?? 0) - (created.get(b.entityId) ?? 0));
    }
    else {
        rows.sort((a, b) => a.displayName.localeCompare(b.displayName, undefined, { sensitivity: 'base' }));
    }
    return rows;
}
/** Parse comma-separated type ids from Entity-List `types=` attribute. */
function parseEntityListTypesAttr(raw) {
    if (raw === undefined || raw === null) {
        return undefined;
    }
    const parts = String(raw)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
    return parts.length > 0 ? parts : undefined;
}
//# sourceMappingURL=computeEntityListRows.js.map